export const isKnownArtist = (artistname) =>
  Boolean(artistname) && artistname !== 'Unknown Artist'
